import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFileLines,
    faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { TaskStatusResponse } from 'queries/InvestmentMemo/useTaskStatus';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

interface TaskStatusDisplayProps {
    taskStatus: TaskStatusResponse;
    dealId: number;
    onDismiss?: () => void;
}

const TaskStatusDisplay = ({
    taskStatus,
    dealId,
    onDismiss,
}: TaskStatusDisplayProps) => {
    const { status, result } = taskStatus;
    const documentId = result?.documentId;

    useEffect(() => {
        if (status === 'FAILURE' && onDismiss) {
            onDismiss();
        }
    }, [status, onDismiss]);

    if (status === 'PENDING' || status === 'PROGRESS') {
        return (
            <div className="d-flex align-items-center justify-content-center mt-2">
                <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
                Generating deck...
            </div>
        );
    }

    if (status === 'SUCCESS' && documentId) {
        return (
            <div className="mt-2">
                <a
                    href={`/deal/${dealId}/documents`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm d-flex text-success align-items-center justify-content-center w-100"
                    onClick={() => {
                        // Clear task from localStorage when user views the document
                        if (onDismiss) {
                            onDismiss();
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faFileLines} className="mr-2" />
                    View deck in Documents
                </a>
            </div>
        );
    }

    if (status === 'FAILURE') {
        return (
            <div className="d-flex align-items-center justify-content-center mt-2">
                <FontAwesomeIcon icon={faTriangleExclamation} className="text-danger mr-2" />
                Error generating deck, please try again
            </div>
        );
    }

    return null;
};

export default TaskStatusDisplay;
